module.exports = __webpack_public_path__ + "img/logo_drcnet.bdf578f6.png";